import { DeleteOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import React from 'react';

interface FormListRemoveButtonProps {
    id?: string;
    name: number;
    isDetailMode: boolean;
    remove: (val: number | number[]) => void;
}

const FormListRemoveButton: React.FC<FormListRemoveButtonProps> = ({
    id,
    isDetailMode,
    remove,
    name,
}: FormListRemoveButtonProps) => (
    <>
        {!isDetailMode && (
            <span className="ant-form-text text-secondary" style={{ marginTop: '5px', cursor: 'pointer' }}>
                <Tag
                    color="red"
                    style={{ cursor: 'pointer' }}
                    onClick={(): void => remove?.(name)}
                    id={id || `remove_${name}`}
                >
                    <DeleteOutlined />
                </Tag>
            </span>
        )}
    </>
);

export default FormListRemoveButton;
